import styles from "./DiscountBadge.module.scss";


export const DiscountBadge = ({oldPrice, newPrice}) => {
    let discount = ((oldPrice - newPrice) / oldPrice) * 100;
    discount = Math.floor(discount);

    if(discount <= 0) {
        return null;
    }
    return (
        <div className={styles.badge}>
            <div className={styles.spinPulseAnimation}>
                <span className={styles.discount}>{discount}</span>
                <span className={styles.percent}>%</span>
            </div>
        </div>
    );
};